import { combine, createEffect, restore } from "effector";
import { toast } from "react-toastify";

import { getUserFriendlyErrorMessage } from "api/UserFriendlyError";
import { getCollections } from "api/media-library";
import { isFullLibrary, UserWithPlan } from "features/media-library";
import { isEditorUploadsCollection } from "utils/cesdk-editor-collection";

export const getCollectionsFx = createEffect(async (user?: UserWithPlan) => {
  const collections = await getCollections();
  // Filter out Editor Uploads collection (managed by ceSDK editor)
  const visibleCollections = collections.filter(
    (c) => !isEditorUploadsCollection(c)
  );
  return isFullLibrary(user)
    ? visibleCollections
    : visibleCollections.filter((c) => c.isSystemInbox);
});

getCollectionsFx.failData.watch((err) => {
  toast.error(getUserFriendlyErrorMessage(err));
});

export const $collections = restore(getCollectionsFx.doneData, []);

export const $store = combine({
  collections: $collections,
  loadingError: restore(getCollectionsFx.failData, null),
  isLoading: getCollectionsFx.pending,
});
